/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import ReactDOM from 'react-dom';
import MegaMenu from './src/mega-menu/MegaMenu';
import { MenuData, MenuLevel, MenuLevelExtra } from './src/models';
import { MobileMenu } from './src/mobile-menu/MobileMenu';
import { initMetaMenu } from './src/meta-menu';
import { initMenuBlocks } from './src/menu-blocks';

function renderMenu(data: MenuData, id: string, component: any) {
    const root = document.getElementById(id);
    if (!root) throw new Error(`Failed to find ${component.name} root element with id ${id}!`);
    ReactDOM.render(React.createElement(component, { data }), root);
}

function parseExtra(data: any): MenuLevelExtra | undefined {
    if (data.field_body && data.field_media && data.field_media.src) {
        return {
            heading: data.title,
            text: data.field_body,
            img: {
                src: data.field_media.src,
                alt: data.field_media.alt,
            },
        };
    }

    return;
}

function parseChild(child: any): MenuLevel {
    return {
        text: child.linkData.title,
        href: child.linkData.link,
        external: child.linkData.external,
        extra: parseExtra(child.linkData),
        children: parseChildren(child.childrenData),
    };
}

function parseChildren(children: any[] | null): MenuLevel[] | undefined {
    if (!children || children.length === 0) return;
    return children.map(parseChild);
}

function parseData(json: string): MenuData {
    const data: any = JSON.parse(json);
    return data.map((root: any) => {
        return {
            text: root.linkData.title,
            href: root.linkData.link,
            external: root.linkData.external,
            viewMode: root.linkData.view_mode,
            blockType: root.linkData.block_type,
            extra: parseExtra(root.linkData),
            children: parseChildren(root.childrenData),
        };
    });
}

let initialized = false;

window.Drupal.behaviors['megaMenu'] = {
    attach: function () {
        if (initialized) return;

        const menuDataScript = document.getElementById('menu-data');
        const megaMenu = document.getElementById('mega-menu');
        const mobileMenu = document.getElementById('mobile-menu');
        const metaMenu = document.getElementById('meta-menu');

        if (!menuDataScript || !megaMenu || !mobileMenu || !metaMenu) return;
        initialized = true;

        const data = parseData(menuDataScript.innerHTML);
        initMetaMenu();
        initMenuBlocks();
        renderMenu(data, 'mega-menu', MegaMenu);
        renderMenu(data, 'mobile-menu', MobileMenu);
    },
};
